import React from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import { useTranslation } from 'react-i18next';
import { useAccess } from '../context/AccessProvider';

/**
 * Hides a page from people whose permission groups (or plan) don't allow it.
 * UX affordance only — the backend rejects the underlying API calls regardless.
 */
const RequirePermission = ({ anyOf = [], feature = [], children }) => {
    const { t } = useTranslation();
    const { can, hasFeature, loading } = useAccess();

    if (loading) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 240 }}>
                <CircularProgress size={28} />
            </Box>
        );
    }

    const permissionOk = anyOf.length === 0 || can(...anyOf);
    const featureOk = feature.length === 0 || feature.some((f) => hasFeature(f));

    if (!permissionOk || !featureOk) {
        return (
            <Box sx={{ px: 1, pt: 1 }}>
                <Alert severity="warning" icon={<LockPersonIcon />}>
                    {permissionOk
                        ? t('access.planRequired', 'This feature is not included in your plan.')
                        : t('access.noPermission', "Your permission groups don't give you access to this page.")}
                </Alert>
            </Box>
        );
    }
    return children;
};

export default RequirePermission;
